// MpfDetails.props.ts
// NHS Design System: https://service-manual.nhs.uk/design-system/components/details
import type { HeadingLevel } from '../MpfInput/MpfInputBaseProps';

export interface MpfDetailsProps {
  summary: string;
  /** Load-bearing: the filters panel starts open on desktop, collapsed on mobile. */
  open?: boolean;
  headingLevel?: HeadingLevel;
  id?: string;
}

// Defaults MUST be values (NOT factories) when using withDefaults
export const mpfDetailsDefaults = {
  open: false,
} satisfies Partial<MpfDetailsProps>;

export type MpfDetailsEmits = {
  (e: 'toggle', open: boolean): void;
};
